import R from 'ramda'
import auto from 'async/auto'
import {defineMessages} from 'react-intl'

import fetchAddressFromCoordinates from './fetchAddressFromCoordinates'
import addNotification from './addNotification'

const messages = defineMessages({
  title: {
    id: 'An error happend', 
    defaultMessage: 'An error happened'
  },
  message: {
    id: "While retrieving the address for this point of interest, an error occured, try again later", 
    defaultMessage: "While retrieving the address for this point of interest, an error occured, try again later"
  }
})

const notification = {type: "error", message: messages.message, title: messages.title}

export default (markerCount, latlng) => (dispatch, getState) => {
    
  const doFetch = (cb) => cb(null, dispatch(fetchAddressFromCoordinates(markerCount ,latlng)))

  auto({
    fetchAddressFromCoordinates: doFetch,
  }, (err, results) => {
    if(err){
      return console.error("Failed to retrieve address for point of interest", err)
    }
  })
}




/** WEBPACK FOOTER **
 ** ./app/actions/updatePoiAddress.js
 **/